import * as React from "react";
import classnames from "classnames";
import { ILayerState } from "../config";
import { LayerAction } from "../enums";

export interface IMenuImageProps {
    layer: ILayerState;
    hideLegend: boolean;
    group: boolean;
    onToggle: (id: string, layerAction: LayerAction) => void;
    tocIcon?: string;
}

export const MenuImage = ({ layer, hideLegend, group, tocIcon, onToggle }: IMenuImageProps): JSX.Element => {
    if (hideLegend) {
        return <span className="arrow" />;
    } else if (layer.error) {
        return <span title={layer.error} className="esri-icon-notice-triangle errorNotice" />;
    } else if ((!group && layer.image && layer.image.length > 0) || tocIcon) {
        return (
            <div className="layerImageContainer">
                {tocIcon ? <img src={tocIcon} /> : <img src={layer && layer.image && layer.image[0].image} />}
            </div>
        );
    } else if (group || layer.sublayers) {
        return (
            <span
                className={classnames(
                    "arrow",
                    { "esri-icon-right": !layer.expanded },
                    { "esri-icon-down": layer.expanded }
                )}
                onClick={() => onToggle(layer.id, LayerAction.Expand)}
            />
        );
    }
    return null;
};
